import * as React from "react";
import { styledRow, title } from "./TemplateOffersList.module.scss";
import Row from "react-bootstrap/Row";

export const StyledRow: React.FC<any> = (props) => {
  return (
    <Row id={props.id} className={styledRow} {...props}>
      {props.children}
    </Row>
  );
};

export const Title: React.FC<any> = (props) => {
  return (
    <h4 className={title} id={props.id}>
      {props.children}
    </h4>
  );
};

export const ShowMoreText: React.FC<any> = (props) => {
  return (
    <a href="#" {...props}>
      {props.children}
    </a>
  );
};
